import { gql } from '@apollo/client';

export const GET_ALLOW_INDIVIDUAL_SHIFT_TIMES = gql`
  query GetAllowIndividualShiftTimes {
    vm {
      configItem(key: "allow-individual-shift-times") {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;
